import { AlertHandlerMutations } from './partials/alert-handler'
import { CachedDropdownsMutations } from './partials/cached-dropdowns'
import { RouteSharedMutations } from './partials/route'
import { SharedSettingsMutations } from './partials/settings'
import { TmetricSharedMutations } from './partials/tmetric'
import { WorkflowSharedMutations } from './partials/workflow'

export const SharedMutations = {
  ...AlertHandlerMutations,
  ...CachedDropdownsMutations,
  ...RouteSharedMutations,
  ...SharedSettingsMutations,
  ...TmetricSharedMutations,
  ...WorkflowSharedMutations,
}
